import request from "@/utils/request";

export function confirmOrder(orderNo) {
  return request({
    url: "/trade/order/h5/confirm/" + orderNo,
    method: "get",
  });
}
export function calcReturnMoney(data) {
  return request({
    url: "/trade/sales-return/h5/calculation",
    method: "post",
    data,
  });
}
export function applyAftSale(data) {
  return request({
    url: "/trade/sales-return/h5/afterSales",
    method: "post",
    data,
  });
}
